import React from "react";

import {
    User,
    Phone,
    Mail,
    Calendar,
    Droplets,
    MapPin
} from "lucide-react";

import "./PersonalForm.css";

function PersonalForm({

    profile,

    setProfile,

}) {

    const handleChange = (e) => {

        const { name, value } = e.target;

        if (name === "city") {

            setProfile({

                ...profile,

                address: {

                    ...profile.address,

                    city: value,

                },

            });

        }

        else {

            setProfile({

                ...profile,

                [name]: value,

            });

        }

    };

    return (

        <div className="edit-card">

            <h2>

                Personal Information

            </h2>

            <div className="form-grid">

                <div className="input-group">

                    <label>

                        <User size={16}/>

                        Full Name

                    </label>

                    <input

                        type="text"

                        name="name"

                        value={profile?.name || ""}

                        onChange={handleChange}

                    />

                </div>

                <div className="input-group">

                    <label>

                        <Phone size={16}/>

                        Mobile Number

                    </label>

                    <input

                        type="text"

                        name="phone"

                        value={profile?.phone || ""}

                        onChange={handleChange}

                    />

                </div>

                <div className="input-group">

                    <label>

                        <Mail size={16}/>

                        Email

                    </label>

                    <input

                        type="email"

                        name="email"

                        value={profile?.email || ""}

                        onChange={handleChange}

                    />

                </div>

                <div className="input-group">

                    <label>

                        <Calendar size={16}/>

                        Date of Birth

                    </label>

                    <input

                        type="date"

                        name="dateOfBirth"

                        value={profile?.dateOfBirth || ""}

                        onChange={handleChange}

                    />

                </div>

                <div className="input-group">

                    <label>

                        <Droplets size={16}/>

                        Blood Group

                    </label>

                    <select

                        name="bloodGroup"

                        value={profile?.bloodGroup || ""}

                        onChange={handleChange}

                    >

                        <option value="">

                            Select

                        </option>

                        <option>O+</option>

                        <option>O-</option>

                        <option>A+</option>

                        <option>A-</option>

                        <option>B+</option>

                        <option>B-</option>

                        <option>AB+</option>

                        <option>AB-</option>

                    </select>

                </div>

                <div className="input-group">

                    <label>

                        <MapPin size={16}/>

                        City

                    </label>

                    <input

                        type="text"

                        name="city"

                        value={profile?.address?.city || ""}

                        onChange={handleChange}

                    />

                </div>

            </div>

        </div>

    );

}

export default PersonalForm;